export default function useKeyHandler(callback, keys) {
  return function (key) {
    if (keys.includes(key)) {
      callback();
      return true;
    }
    return false;
  };
}
